<template>
  <v-row>
    <v-col cols="12">
      <e-label class="font-weight-medium">Conteúdo</e-label>
      <p class="font-weight-regular saltar-linha">
        {{ aula.conteudo }}
      </p>
    </v-col>
    <v-col cols="12">
      <e-label class="font-weight-medium">Metodologia</e-label>
      <p class="font-weight-regular saltar-linha">
        {{ aula.metodologia }}
      </p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ConteudoAulaRegular",
  props: {
    aula: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.saltar-linha {
  white-space: pre-line;
}
</style>
